/* eslint @typescript-eslint/no-explicit-any: 'off' */

// https://stackoverflow.com/a/52445008
export const tuple = <T extends any[]>(...args: T): T => args

// https://jpwilliams.dev/how-to-unpack-the-return-type-of-a-promise-in-typescript
export type AsyncReturnType<T extends (...args: any) => any> =
  T extends (...args: any) => Promise<infer U> ? U :
  T extends (...args: any) => infer U ? U :
  any

// This is a utility method to ensure the properties we provide fully
// initialize an interface. Unfortunately, it's a solution for a semantics
// nitpick with a potential runtime cost. (It's possible the function will be
// inlined.) By default, however, I'd rather use this instead of having to
// declare temporary variables in what otherwise might be one line closures.
//
// See https://github.com/microsoft/TypeScript/issues/7481
export const create = <T>(props: T): T => props

export type JsonPrimitive = null | boolean | number | string
export type JsonArray = Array<JsonAny>
/**
 * Using [[`Partial`]] to define this type means we can assign `undefined` to
 * any key, but [[`JSON.stringify`]] will omit these keys, so it's not a big
 * issue. The positive side effect is that accessing a key in a JSON object can
 * return undefined if the key does not exist.
 *
 * Also see https://github.com/microsoft/TypeScript/issues/13195
 */
export type JsonObject = Partial<{[key: string]: JsonAny}>
export type JsonAny = JsonPrimitive | JsonArray | JsonObject

// Inspired by https://dev.to/babak/exhaustive-type-checking-with-typescript-4l3f
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function checkExhaustive (param: never): never {
  throw new Error('exhaustiveCheck failed')
}

export function checkPresent<T> (p: T): asserts p is Exclude<T, null | undefined> {
  if (p === null) throw new Error('null not allowed')
  if (p === undefined) throw new Error('undefined not allowed')
}

export function ifNull<A, B> (a: A | null, b: B): A | B {
  if (a === null) return b
  else return a
}

export function ifUndef<A, B> (a: A | undefined, b: B): A | B {
  if (a === undefined) return b
  else return a
}

// https://medium.com/@KevinBGreene/surviving-the-typescript-ecosystem-branding-and-type-tagging-6cf6e516523d
export type Brand<K, T> = K & { __brand: T }
